// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3fSLF","innerContainer":"styles_innerContainer__pcm_X","title":"styles_title__155rT"};